import { useGetMealTypePreference } from "../use-get-meal-type-preference-lifestyle";
import { useUpdateMealTypePreference } from "../use-update-meal-type-preference-lifestyle";

export const useMealTypePreference = () => {
  const { mealTypePreference, isLoading, isError, error } =
    useGetMealTypePreference();

  const {
    updateMealTypePreference,
    updateMealTypePreferenceAsync,
    isUpdating,
    isError: isUpdateError,
    error: updateError,
  } = useUpdateMealTypePreference();

  return {
    mealTypePreference,
    isLoading,
    isError,
    error,
    updateMealTypePreference,
    updateMealTypePreferenceAsync,
    isUpdating,
    isUpdateError,
    updateError,
  };
};
